import { useState } from "react";
import { XCircle } from "@untitledui/icons";
import { ModalOverlay, Modal, Dialog } from "@/components/application/modals/modal";
import { Button } from "@/components/base/buttons/button";
import { Input } from "@/components/base/input/input";
import { useTranslation } from "react-i18next";

interface CreateContainerIdModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (containerId: string) => void;
}

export const CreateContainerIdModal = ({ isOpen, onClose, onSubmit }: CreateContainerIdModalProps) => {
    const { t } = useTranslation("common");
    const [containerId, setContainerId] = useState("");

    const handleSubmit = () => {
        const trimmed = containerId.trim();
        if (!trimmed) return;
        onSubmit(trimmed);
        setContainerId("");
        onClose();
    };

    const handleClose = () => {
        setContainerId("");
        onClose();
    };

    return (
        <ModalOverlay isOpen={isOpen} onOpenChange={(open) => !open && handleClose()}>
            <Modal>
                <Dialog>
                    <div className="rounded-xl bg-primary p-6 shadow-lg ring-1 ring-secondary w-full max-w-md">
                        <div className="flex items-center justify-between mb-6">
                            <h2 className="text-xl font-semibold text-primary">
                                {t("aiChat.createContainerModal.title")}
                            </h2>
                            <button
                                onClick={handleClose}
                                className="text-tertiary hover:text-primary rounded p-1"
                                aria-label={t("aiChat.createContainerModal.cancel")}
                            >
                                <XCircle className="size-5" />
                            </button>
                        </div>
                        <div className="mb-6">
                            <Input
                                label={t("aiChat.createContainerModal.containerIdPlaceholder")}
                                placeholder={t("aiChat.createContainerModal.containerIdPlaceholder")}
                                value={containerId}
                                onChange={(value) => setContainerId(value)}
                                onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
                                autoFocus
                            />
                        </div>
                        <div className="flex justify-end gap-3">
                            <Button onClick={handleClose} color="secondary" size="md">
                                {t("aiChat.createContainerModal.cancel")}
                            </Button>
                            <Button
                                onClick={handleSubmit}
                                color="primary"
                                size="md"
                                isDisabled={!containerId.trim()}
                            >
                                {t("aiChat.createContainerModal.submit")}
                            </Button>
                        </div>
                    </div>
                </Dialog>
            </Modal>
        </ModalOverlay>
    );
};
